import React, { PureComponent, ReactNode } from "react";
import { AppContextType, HelpPageName } from "../../AppContext";
import "./AppErrorPopup.css";
import CloseableModal from "./CloseableModal";
import InfoCard from "../layout_reuse/InfoCard";
import IconButton from "../theme_reuse/IconButton";

interface Props {}
interface State {}

class AppErrorPopup extends PureComponent<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;

  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  handleCloseModal = () => {
    this.context.dispatch({ type: "ClearErrorList" });
  };
  handleOpenHelpPage = () => {
    this.context.dispatch({ type: "ShowHelpPage", payload: HelpPageName.Overview });
  };

  render(): ReactNode {
    const { errorList } = this.context.errors;
    if (!errorList.length) {
      return undefined;
    }
    return (
      <CloseableModal onClose={this.handleCloseModal}>
        <InfoCard>
          <div className="app-error-popup-list">
            {errorList.map((e) => {
              return (
                <div key={e} className="app-error-popup-text">
                  {e}
                </div>
              );
            })}
          </div>
          <div className="app-error-help-text">
            <p>Try reloading the page, or try a different browser.</p>
            <p>
              See the <IconButton icon="Help page" onClick={this.handleOpenHelpPage} /> to get more insight or to report a bug.
            </p>
          </div>
        </InfoCard>
      </CloseableModal>
    );
  }
}

// Not sure if actually needed.  The context knows whether this thing is open... must close it.
AppErrorPopup.contextType = AppContextType;

export default AppErrorPopup;
